import { Link } from "react-router-dom"
import s from "./styles.module.css"

const navLinks = [
  { to: "/documents/personal-data-processing-policy", label: "Положение об обработке персональных данных" },
  { to: "/documents/consent-to-personal-data-processing", label: "Согласие на обработку персональных данных" },
  { to: "/documents/user-agreement", label: "Пользовательское соглашение"},
  { to: "/documents", label: "Политика конфиденциальности"},
];

const categoryLinks = [
  { to: "/category/games", label: "Игры в Москве" },
  { to: "/category/love", label: "Знакомства в Москве" },
  { to: "/category/parties", label: "Вечеринки в Москве" },
  { to: "/category/education", label: "Мастер-классы в Москве" },
  { to: "/category/culture", label: "Культурные события" },
  { to: "/category/sport", label: "Спорт в Москве" },
  { to: "/category/walking", label: "Прогулки по Москве" },
];

const PrivacyLinks = () => {
  return (
    <div className={s.privacy_links_container}>
      {categoryLinks.map((link) => (
        <Link key={link.to} to={link.to} className={s.privacy_link} title={link.label}>
          {link.label}
        </Link>
      ))}
      {navLinks.map((link) => (
        <Link key={link.to} to={link.to} className={s.privacy_link} title={link.label}>
          {link.label}
        </Link>
      ))}
    </div>
  );
};

export default PrivacyLinks;